import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { HomePageComponent } from './home-page/home-page.component'
import { AboutInstituteComponent } from './about-institute/about-institute.component'
import { AboutRgiComponent } from './about-rgi/about-rgi.component'
import { VisionMissionComponent } from './vision-mission/vision-mission.component'
import { ChairmanMessageComponent } from './chairman-message/chairman-message.component'
import { PrincipalMessageComponent } from './principal-message/principal-message.component'
import { CoreValuesComponent } from './core-values/core-values.component'
import { RtiActComponent } from './rti-act/rti-act.component'
import { AdmissionOverviewComponent } from './admission-overview/admission-overview.component'
import { StudentScholarshipComponent } from './student-scholarship/student-scholarship.component'
import { RgiScholarshipComponent } from './rgi-scholarship/rgi-scholarship.component'
import { AdmissionHelplineComponent } from './admission-helpline/admission-helpline.component'
import { FaqsComponent } from './faqs/faqs.component'
import { PlacementDetailsComponent } from './placement-details/placement-details.component'
import { OnlineFeesPaymentComponent } from './online-fees-payment/online-fees-payment.component'
import { ContactComponent } from './contact/contact.component'
import { AcademicAuditReportsComponent } from './academic-audit-reports/academic-audit-reports.component'
import { ResearchAndPublicationComponent } from './research-and-publication/research-and-publication.component'
import { AcademicsCalendarComponent } from './academics-calendar/academics-calendar.component'
import { BbaCollegesNagpurComponent } from './bba-colleges-nagpur/bba-colleges-nagpur.component'
import { BccaCollegesNagpurComponent } from './bcca-colleges-nagpur/bcca-colleges-nagpur.component'
import { BachelorOfComputerApplicationComponent } from './bachelor-of-computer-application/bachelor-of-computer-application.component'
import { MasterOfComputerManagementComponent } from './master-of-computer-management/master-of-computer-management.component'
import { MscComputerScienceComponent } from './msc-computer-science/msc-computer-science.component'
import { PlacementProcessComponent } from './placement-process/placement-process.component'
import { PlacementTeamComponent } from './placement-team/placement-team.component'
import { InternshipComponent } from './internship/internship.component'
import { OurRecruitersComponent } from './our-recruiters/our-recruiters.component'
import { TestimonialsComponent } from './testimonials/testimonials.component'
import { RocsComponent } from './rocs/rocs.component'
import { StudentLifeComponent } from './student-life/student-life.component'
import { SportsComponent } from './sports/sports.component'
import { LibraryComponent } from './library/library.component'
import { LabsComponent } from './labs/labs.component'
import { LatestNewsComponent } from './latest-news/latest-news.component'
import { StudentSpeakComponent } from './student-speak/student-speak.component'
import { AboutAlumniComponent } from './about-alumni/about-alumni.component'
import { AlumniSpeakComponent } from './alumni-speak/alumni-speak.component'
import { AlumniEventsComponent } from './alumni-events/alumni-events.component'
import { EventsComponent } from './events/events.component'
import { CocurricularEventsComponent } from './cocurricular-events/cocurricular-events.component'
import { ExtraCurricularEventsComponent } from './extra-curricular-events/extra-curricular-events.component'
import { IqacComponent } from './iqac/iqac.component'
import { SsrComponent } from './ssr/ssr.component'
import { ClarificationComponent } from './clarification/clarification.component'
import { KimbaComponent } from './kimba/kimba.component'
import { NotFoundComponent } from './not-found/not-found.component'
import { ThankYouComponent } from './thank-you/thank-you.component'
import { CityOfficeComponent } from './city-office/city-office.component'
import { BlogsComponent } from './blogs/blogs.component'
import { BestBbaPlacementCollegesIndiaComponent } from './best-bba-placement-colleges-india/best-bba-placement-colleges-india.component'
import { TmExpressComponent } from './tm-express/tm-express.component'
import { AarambhInductionComponent } from './aarambh-induction/aarambh-induction.component'
import { GoverningBodyComponent } from './governing-body/governing-body.component'
import { BscFinanceComponent } from './bsc-finance/bsc-finance.component'
import { BscEconomicsComponent } from './bsc-economics/bsc-economics.component'
import { BcomHonorsComponent } from './bcom-honors/bcom-honors.component'
import { BaHonorsEonomicsComponent } from './ba-honors-eonomics/ba-honors-eonomics.component'
import { BscDataScienceComponent } from './bsc-data-science/bsc-data-science.component'
import { CommitteeComponent } from './committee/committee.component'
import { InstituteAntiRaggingCommitteeComponent } from './institute-anti-ragging-committee/institute-anti-ragging-committee.component'
import { AntiRaggingSquadComponent } from './anti-ragging-squad/anti-ragging-squad.component'
import { GrievanceRedressalCommitteeComponent } from './grievance-redressal-committee/grievance-redressal-committee.component'
import { WomanDevelopmentCellComponent } from './woman-development-cell/woman-development-cell.component'
import { AntiSexualHarassmentGrievanceCellComponent } from './anti-sexual-harassment-grievance-cell/anti-sexual-harassment-grievance-cell.component'
import { TrainingAndPlacementCellAndThreeCellComponent } from './training-and-placement-cell-and-three-cell/training-and-placement-cell-and-three-cell.component'
import { InternalComplaintCommitteeComponent } from './internal-complaint-committee/internal-complaint-committee.component'
import { FutureOfBScDataScienceComponent } from './future-of-bsc-data-science/future-of-bsc-data-science.component'
import { BscInFinanceComponent } from './bsc-in-finance/bsc-in-finance.component'
import { AdmissionInBBAComponent } from './admission-in-bba/admission-in-bba.component'
import { MscInComputerScienceComponent } from './msc-in-computer-science/msc-in-computer-science.component'
import { TopBCACollegesInIndiaComponent } from './top-bca-colleges-in-india/top-bca-colleges-in-india.component'
import { FeesStructuresComponent } from './fees-structures/fees-structures.component'
import { FutureOfDataScienceComponent } from './future-of-data-science/future-of-data-science.component'
import { SpecializationForYourMScInComputerScienceComponent } from './specialization-for-your-m-sc-in-computer-science/specialization-for-your-m-sc-in-computer-science.component'
import { TopMastersProgramsInComputerManagementComponent } from './top-masters-programs-in-computer-management/top-masters-programs-in-computer-management.component'
import { BComHonoursProgramComponent } from './b-com-honours-program/b-com-honours-program.component'
import { BscEconomicsAndFinanceComponent } from './bsc-economics-and-finance/bsc-economics-and-finance.component'
import { EngfinityClubInstallationPressReleaseComponent } from './engfinity-club-installation-press-release/engfinity-club-installation-press-release.component'
import { BestCollegesBaDigitalMarketingNagpurComponent } from './best-colleges-ba-digital-marketing-nagpur/best-colleges-ba-digital-marketing-nagpur.component'
import { BcomComputerApplicationComponent } from './bcom-computer-application/bcom-computer-application.component'
import { BscEconomicsProgramTipsComponent } from './bsc-economics-program-tips/bsc-economics-program-tips.component'
import { FutureBscItCareerOpportunitiesComponent } from './future-bsc-it-career-opportunities/future-bsc-it-career-opportunities.component'
import { BusinessGuideBbaCoursesComponent } from './business-guide-bba-courses/business-guide-bba-courses.component'
import { ECommerceDigitalMarketingEnhancingComponent } from './e-commerce-digital-marketing-enhancing/e-commerce-digital-marketing-enhancing.component'
import { GyanManthanComponent } from './gyan-manthan/gyan-manthan.component'
import { ToastmastersClubComponent } from './toastmasters-club/toastmasters-club.component'
import { InductionProgramComponent } from './induction-program/induction-program.component'
import { RaisoniMandiComponent } from './raisoni-mandi/raisoni-mandi.component'
import { FarewellPartyComponent } from './farewell-party/farewell-party.component'
import { FarewellCeremonyComponent } from './farewell-ceremony/farewell-ceremony.component'
import { CynosureComponent } from './cynosure/cynosure.component'
import { InstallationProgramComponent } from './installation-program/installation-program.component'
import { RakhiMakingCompetitionComponent } from './rakhi-making-competition/rakhi-making-competition.component'
import { MissionVotingCampingComponent } from './mission-voting-camping/mission-voting-camping.component'
import { GaneshChaturthiComponent } from './ganesh-chaturthi/ganesh-chaturthi.component'
import { InstallationCeremonyComponent } from './installation-ceremony/installation-ceremony.component'
import { EngfinityClubComponent } from './engfinity-club/engfinity-club.component'
import { BigBossComponent } from './big-boss/big-boss.component'
import { TopBscFinanceCollegesNagpurComponent } from './top-bsc-finance-colleges-nagpur/top-bsc-finance-colleges-nagpur.component'
import { DeepMilanComponent } from './deep-milan/deep-milan.component'
import { NewsAnalysisComponent } from './news-analysis/news-analysis.component'
import { MandatoryDisclosureComponent } from './mandatory-disclosure/mandatory-disclosure.component'
import { McmCourseInNagpurComponent } from './mcm-course-in-nagpur/mcm-course-in-nagpur.component'
import { MscComputerScienceCollegesInNagpurComponent } from './msc-computer-science-colleges-in-nagpur/msc-computer-science-colleges-in-nagpur.component'
import { KiteFlyingFestivalComponent } from './kite-flying-festival/kite-flying-festival.component'
import { FarewellPartyTwentyfiveComponent } from './farewell-party-twentyfive/farewell-party-twentyfive.component'
import { Engfinity2025Component } from './engfinity2025/engfinity2025.component'
import { CreatingUnicornComponent } from './creating-unicorn/creating-unicorn.component'
import { MissNationCompetitionComponent } from './miss-nation-competition/miss-nation-competition.component'
import { PickleballInaugurationComponent } from './pickleball-inauguration/pickleball-inauguration.component'
import { ToastmastersComponent } from './toastmasters/toastmasters.component'
import { SadaGyanSeriesComponent } from './sada-gyan-series/sada-gyan-series.component'
import { EventsNewComponent } from './events-new/events-new.component'
import { KashtiInaugurationComponent } from './kashti-inauguration/kashti-inauguration.component'
import { RaisoniPremierLeagueComponent } from './raisoni-premier-league/raisoni-premier-league.component'
import { ChatrapatiShivajiMaharajJayntiComponent } from './chatrapati-shivaji-maharaj-jaynti/chatrapati-shivaji-maharaj-jaynti.component'
import { SetuComponent } from './setu/setu.component'
import { RaheComponent } from './rahe/rahe.component'
import { FarewellComponent } from './farewell/farewell.component'

const routes: Routes = [
  {
    path: '',
    component: HomePageComponent,
    data: {
      keywords:
        'G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description:
        'G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      title: 'G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR'
    }
  },
  {
    path: 'about-institute',
    component: AboutInstituteComponent,
    data: {
      keywords:
        'About Institute || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'About Institute || G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'About Institute || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'about-rgi',
    component: AboutRgiComponent,
    data: {
      keywords:
        'About RGI || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'About RGI || G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'About RGI || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'vision-mission',
    component: VisionMissionComponent,
    data: {
      keywords:
        'Vision Mission || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Vision Mission || G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'Vision Mission || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'chairman-message',
    component: ChairmanMessageComponent,
    data: {
      keywords:
        'Chairman Message || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Read the Chairmans message at G H Raisoni College of Arts, Commerce, Science, Nagpur.Inspiring students towards academic excellence and success.',
      title:
        'Chairman Message || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'principal-message',
    component: PrincipalMessageComponent,
    data: {
      keywords:
        'Principal Message || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Read the Principals message at G H Raisoni College of Arts, Commerce, Science, Nagpur.Inspiring students towards academic excellence and success.',
      title:
        'Principal Message || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'core-values',
    component: CoreValuesComponent,
    data: {
      keywords: 'Core Values || GHRCACSN',
      description:
        'Discover the core values of GH Raisoni College of Arts, Commerce, Science, Nagpur. Committed to excellence, integrity, and holistic education.',
      title: 'Core Values || GHRCACSN'
    }
  },
  {
    path: 'rti-act',
    component: RtiActComponent,
    data: {
      keywords:
        'RTI Act ||  G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description:
        'RTI Act ||  G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      title:
        'RTI Act ||  G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR'
    }
  },
  {
    path: 'admission-overview',
    component: AdmissionOverviewComponent,
    data: {
      keywords:
        'Admission Overview || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Admission Overview || G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'Admission Overview || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'student-scholarship',
    component: StudentScholarshipComponent,
    data: {
      keywords:
        'Students Scholarship || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Students Scholarship || G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'Students Scholarship || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'rgi-scholarship',
    component: RgiScholarshipComponent,
    data: {
      keywords:
        'RGI Scholarship || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description:
        'RGI Scholarship || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      title:
        'RGI Scholarship || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR'
    }
  },
  {
    path: 'admission-helpline',
    component: AdmissionHelplineComponent,
    data: {
      keywords:
        'Admission Helpline || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Admission Helpline ||  G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR      ',
      title:
        'Admission Helpline || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'faqs',
    component: FaqsComponent,
    data: {
      keywords: 'FAQs || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'FAQs || G H Raisoni College of Arts, Commerce, Science Nagpur',
      title: 'FAQs || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'online-fees-payment',
    component: OnlineFeesPaymentComponent,
    data: {
      keywords:
        'Online Fess Payment || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Online Fess Payment || G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'Online Fess Payment || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'contact',
    component: ContactComponent,
    data: {
      keywords:
        'Contact || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Contact G H Raisoni College of Arts, Commerce, Science, Nagpur for admissions and inquiries. Get in touch for information and assistance.',
      title: 'Contact || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'academic-audit-reports',
    component: AcademicAuditReportsComponent,
    data: {
      keywords:
        'Academic Audit Reports || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Academic Audit Reports || G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'Academic Audit Reports || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'research-and-publication',
    component: ResearchAndPublicationComponent,
    data: {
      keywords:
        'Research and Publication || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description:
        'Research and Publication || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      title:
        'Research and Publication || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR'
    }
  },
  {
    path: 'academics-calendar',
    component: AcademicsCalendarComponent,
    data: {
      keywords:
        'Academics Calendar || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Academics Calendar || G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'Academics Calendar || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'bba-colleges-nagpur',
    component: BbaCollegesNagpurComponent,
    data: {
      keywords: 'Best BBA College in Nagpur Maharashtra | GHRCACSN',
      description:
        'G H Raisoni College of Arts, Commerce, Science Nagpur is one of the best BBA colleges in Nagpur Maharashtra. Register now for the BBA admission',
      title: 'Best BBA College in Nagpur Maharashtra | GHRCACSN'
    }
  },
  {
    path: 'bachelor-of-computer-application',
    component: BachelorOfComputerApplicationComponent,
    data: {
      keywords: 'Best BCA College in Nagpur Maharashtra | GHRCACSN',
      description:
        'G H Raisoni College of Arts, Commerce, Science Nagpur is one of the best BCA colleges in Nagpur Maharashtra. Register now for the BCA admission',
      title: 'Best BCA College in Nagpur Maharashtra | GHRCACSN'
    }
  },
  {
    path: 'bachelor-of-computer-application',
    component: BachelorOfComputerApplicationComponent,
    data: {
      keywords: 'Best BCA College in Nagpur Maharashtra | GHRCCST',
      description:
        'G H Raisoni College of Commerce, Science, and Technology is one of the best BCA colleges in Nagpur Maharashtra.  Register now for the BCA admission',
      title: 'Best BCA College in Nagpur Maharashtra | GHRCCST'
    }
  },
  {
    path: 'msc-computer-science',
    component: MscComputerScienceComponent,
    data: {
      keywords: 'Best M.SC College in Nagpur Maharashtra | GHRCACSN',
      description:
        'G H Raisoni College of Arts, Commerce, Science Nagpur is one of the best M.SC colleges in Nagpur Maharashtra. Register now for the M.SC admission',
      title: 'Best M.SC College in Nagpur Maharashtra | GHRCACSN'
    }
  },
  {
    path: 'master-of-computer-management',
    component: MasterOfComputerManagementComponent,
    data: {
      keywords: 'Best MCM College in Nagpur Maharashtra | GHRCACSN',
      description:
        'G H Raisoni College of Arts, Commerce, Science Nagpur is one of the best MCM colleges in Nagpur Maharashtra. Register now for the MCM admission',
      title: 'Best MCM College in Nagpur Maharashtra | GHRCACSN'
    }
  },

  {
    path: 'bcca-colleges-nagpur',
    component: BccaCollegesNagpurComponent,
    data: {
      keywords:
        'BCCA Course- Best Commerce College in Nagpur Maharashtra | GHRCACSN',
      description:
        'G H Raisoni College of Arts, Commerce, Science Nagpur is one of the best commerce colleges in Nagpur Maharashtra that offers BCCA Course Admission.',
      title:
        'BCCA Course- Best Commerce College in Nagpur Maharashtra | GHRCACSN'
    }
  },
  {
    path: 'placement-process',
    component: PlacementProcessComponent,
    data: {
      keywords:
        'Placement Process ||  G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description:
        'Placement Process ||  G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      title:
        'Placement Process ||  G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR'
    }
  },
  {
    path: 'placement-team',
    component: PlacementTeamComponent,
    data: {
      keywords:
        'Placement Team || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description:
        'Placement Team || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      title:
        'Placement Team || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR'
    }
  },
  {
    path: 'internship',
    component: InternshipComponent,
    data: {
      keywords:
        'Internship  || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description:
        'Internship  || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      title:
        'Internship  || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR'
    }
  },
  {
    path: 'our-recruiters',
    component: OurRecruitersComponent,
    data: {
      keywords:
        'Our Recruiters||  G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description:
        'Our Recruiters||  G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      title:
        'Our Recruiters||  G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR'
    }
  },
  {
    path: 'testimonials',
    component: TestimonialsComponent,
    data: {
      keywords:
        'Testimonials || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description:
        'Testimonials || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      title:
        'Testimonials || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR'
    }
  },
  {
    path: 'rocs',
    component: RocsComponent,
    data: {
      keywords:
        'Rocs ||  G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description:
        'Rocs ||  G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      title:
        'Rocs ||  G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR'
    }
  },
  {
    path: 'placement-details',
    component: PlacementDetailsComponent,
    data: {
      keywords:
        'Placement Details ||  G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description:
        'Placement Details ||  G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      title:
        'Placement Details ||  G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR'
    }
  },
  {
    path: 'student-life',
    component: StudentLifeComponent,
    data: {
      keywords:
        'Student Life || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Student Life || G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'Student Life || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'sports',
    component: SportsComponent,
    data: {
      keywords:
        'Sports || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Explore sports activities at G H Raisoni College of Arts, Commerce, Science, Nagpur. Engage in physical fitness and team spirit for holistic development.',
      title: 'Sports || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'library',
    component: LibraryComponent,
    data: {
      keywords:
        'Library || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Library || G H Raisoni College of Arts, Commerce, Science Nagpur',
      title: 'Library || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'labs',
    component: LabsComponent,
    data: {
      keywords: 'Labs || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Labs || G H Raisoni College of Arts, Commerce, Science Nagpur',
      title: 'Labs || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'latest-news',
    component: LatestNewsComponent,
    data: {
      keywords:
        'Latest News || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Latest News || G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'Latest News || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'student-speak',
    component: StudentSpeakComponent,
    data: {
      keywords:
        'Student Speak || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Student Speak || G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'Student Speak || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'about-alumni',
    component: AboutAlumniComponent,
    data: {
      keywords:
        'About Alumni || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description:
        'About Alumni || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      title:
        'About Alumni || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR'
    }
  },
  {
    path: 'alumni-speak',
    component: AlumniSpeakComponent,
    data: {
      keywords:
        'Alumni Speak || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Alumni Speak || G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'Alumni Speak || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'alumni-events',
    component: AlumniEventsComponent,
    data: {
      keywords:
        'Alumni Events || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Alumni Events || G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'Alumni Events || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'events',
    component: EventsComponent,
    data: {
      keywords:
        'events || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description:
        'Discover upcoming events at G H Raisoni College, Nagpur. Engage in enriching activities and academic gatherings.',
      title:
        'events || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR'
    }
  },
  {
    path: 'extra-curricular-events',
    component: ExtraCurricularEventsComponent,
    data: {
      keywords:
        ' Extra Curricular Events || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        ' Engage in extra-curricular events at G H Raisoni College of Arts, Commerce, Science, Nagpur. Enhance skills and enjoy diverse activities beyond academics.',
      title:
        ' Extra Curricular Events || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'cocurricular-events',
    component: CocurricularEventsComponent,
    data: {
      keywords:
        'Cocurricular Events || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Discover extracurricular events at G H Raisoni College, Nagpur. Enhance skills and experiences beyond academics.',
      title:
        'Cocurricular Events || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'iqac',
    component: IqacComponent,
    data: {
      keywords: 'IQAC || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Learn about the IQAC at G H Raisoni College of Arts, Commerce, Science, Nagpur. Ensuring quality education and continuous improvement for students.',
      title: 'IQAC || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'ssr',
    component: SsrComponent,
    data: {
      keywords:
        'SSR || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description:
        'SSR || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      title:
        'SSR || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR'
    }
  },
  {
    path: 'clarification',
    component: ClarificationComponent,
    data: {
      keywords:
        'Clarification || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description:
        'Clarification || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      title:
        'Clarification || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR'
    }
  },
  {
    path: 'kimba',
    component: KimbaComponent,
    data: {
      keywords:
        'Kimba || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Explore Kimba at G H Raisoni College of Arts, Commerce, Science, Nagpur. Engage in vibrant student life and academic excellence.',
      title: 'Kimba || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: '404',
    component: NotFoundComponent,
    data: {
      keywords:
        '404 || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description:
        '404 || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      title:
        '404 || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR'
    }
  },
  {
    path: 'thank-you',
    component: ThankYouComponent,
    data: {
      keywords:
        'Thank You || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description:
        'Thank You || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      title:
        'Thank You || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR'
    }
  },
  {
    path: 'city-office',
    component: CityOfficeComponent,
    data: {
      keywords:
        'City Office || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Visit our city office for G H Raisoni College of Arts, Commerce, Science, Nagpur. Get information and assistance for admissions and inquiries.',
      title:
        'City Office || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'best-bba-placement-colleges-india',
    component: BestBbaPlacementCollegesIndiaComponent,
    data: {
      keywords: 'How to Choose Best BBA Placement Colleges in India | GHRCACSN',
      description:
        'G H Raisoni College of Arts, Commerce, Science Nagpur  is one of the best BBA placement colleges in India that provides quality education with the best teaching facilities.',
      title: 'How to Choose Best BBA Placement Colleges in India | GHRCACSN'
    }
  },
  {
    path: 'blogs',
    component: BlogsComponent,
    data: {
      keywords:
        'Blogs || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Blogs || G H Raisoni College of Arts, Commerce, Science Nagpur',
      title: 'Blogs || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'tm-express',
    component: TmExpressComponent,
    data: {
      keywords:
        'TM Express || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'TM Express || G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'TM Express || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'aarambh-induction',
    component: AarambhInductionComponent,
    data: {
      keywords:
        'Aarambh Induction || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description:
        'Aarambh Induction || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      title:
        'Aarambh Induction || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR'
    }
  },
  {
    path: 'governing-body',
    component: GoverningBodyComponent,
    data: {
      keywords:
        'Governing Body || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Governing Body || G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'Governing Body || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'bsc-finance',
    component: BscFinanceComponent,
    data: {
      keywords:
        'BSC finance || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Explore BSc Finance at G H Raisoni College of Arts, Commerce, Science, Nagpur. Gain expertise in financial management for a successful career.',
      title:
        'BSC finance || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'bsc-economics',
    component: BscEconomicsComponent,
    data: {
      keywords:
        'Bsc Economics || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Discover BSc Economics at G H Raisoni College, Nagpur. Learn economic theories and practical applications for real-world impact.',
      title:
        'Bsc Economics || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'bcom-honors',
    component: BcomHonorsComponent,
    data: {
      keywords:
        'Bcom Honors || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Explore BCom Honors at G H Raisoni College, Nagpur. Get thorough commerce education and skills for a successful career',
      title:
        'Bcom Honors || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'ba-honors-eonomics',
    component: BaHonorsEonomicsComponent,
    data: {
      keywords:
        'BA Honors Eonomics || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Explore BA Honors Economics at G H Raisoni College of Arts, Commerce, Science, Nagpur. Empowering students with in-depth knowledge and skills.',
      title:
        'BA Honors Eonomics || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'bsc-data-science',
    component: BscDataScienceComponent,
    data: {
      keywords:
        'Bsc Data Science || G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Discover BSc Data Science at G H Raisoni College of Arts, Commerce, Science, Nagpur. Equip yourself with cutting-edge skills for the data-driven world.',
      title:
        'Bsc Data Science || G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'committee',
    component: CommitteeComponent,
    data: {
      keywords:
        'Governing Body || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description:
        'Governing Body || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      title:
        'Bsc Data Science || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR'
    }
  },
  {
    path: 'institute-anti-ragging-committee',
    component: InstituteAntiRaggingCommitteeComponent,
    data: {
      keywords:
        'Institute Anti-Ragging Committee | G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Discover the Institute Anti-Ragging Committee at GH Raisoni College of Arts, Commerce, Science, Nagpur. Ensuring a safe and respectful campus environment.',
      title:
        'Institute Anti-Ragging Committee | G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'anti-ragging-squad',
    component: AntiRaggingSquadComponent,
    data: {
      keywords:
        'Anti-Ragging Squad | G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Explore the Anti-Ragging Squad at G H Raisoni College of Arts, Commerce, Science Nagpur Ensuring a safe campus environment.',
      title:
        'Anti-Ragging Squad | G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'grievance-redressal-committee',
    component: GrievanceRedressalCommitteeComponent,
    data: {
      keywords:
        'Grievance Redressal Committee | G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Explore the Grievance Redressal Committee at G H Raisoni College of Arts, Commerce, Science Nagpur.  Ensuring student welfare and resolving issues effectively.',
      title:
        'Grievance Redressal Committee | G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'woman-development-cell',
    component: WomanDevelopmentCellComponent,
    data: {
      keywords:
        'Woman Development Cell | GH Raisoni College of Arts, Commerce, Science',
      description:
        'Discover the Woman Development Cell at GH Raisoni College of Arts, Commerce, Science, Nagpur. Empowering women for personal and professional growth.',
      title:
        'Woman Development Cell | GH Raisoni College of Arts, Commerce, Science'
    }
  },
  {
    path: 'anti-sexual-harassment-grievance-cell',
    component: AntiSexualHarassmentGrievanceCellComponent,
    data: {
      keywords:
        'Anti-Sexual Harassment Cell | G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Discover the Anti-Sexual Harassment Grievance Cell at G H Raisoni College of Arts, Commerce, Science Nagpur. Ensuring a safe campus.',
      title:
        'Anti-Sexual Harassment Cell | G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'training-and-placement-cell-and-three-cell',
    component: TrainingAndPlacementCellAndThreeCellComponent,
    data: {
      keywords:
        'Training and Placement Cell | GH Raisoni College of Arts, Commerce, Science',
      description:
        'Explore the Training and Placement Cell at GH Raisoni College of Arts, Commerce, Science, Nagpur. Guiding students towards career success and opportunities',
      title:
        'Training and Placement Cell | GH Raisoni College of Arts, Commerce, Science'
    }
  },
  {
    path: 'internal-complaint-committee',
    component: InternalComplaintCommitteeComponent,
    data: {
      keywords:
        ' Internal Complaint Committee | G H Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Explore the Internal Complaint Committee at G H Raisoni College of Arts, Commerce, Science Nagpur. Ensuring a safe and supportive campus environment.',
      title:
        ' Internal Complaint Committee | G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },

  {
    path: 'future-of-bsc-data-science',
    component: FutureOfBScDataScienceComponent,
    data: {
      keywords:
        'The Future of BSc Data Science: Trends and Predictions for the Industry',
      description:
        'The outlook for BSc Data Science is optimistic. The discipline is expanding swiftly, and skilled data scientists are in high demand.',
      title:
        'The Future of BSc Data Science: Trends and Predictions for the Industry'
    }
  },
  {
    path: 'bsc-in-finance',
    component: BscInFinanceComponent,
    data: {
      keywords:
        'Admission Requirements for BSc in Finance: What You Need to Know Before Applying',
      description:
        'BSc in Finance is not a cup for everyone. Unlike the UG in BBA Finance, one must go through an extensive study phase during BSc in Finance.',
      title:
        'Admission Requirements for BSc in Finance: What You Need to Know Before Applying'
    }
  },
  {
    path: 'admission-in-bba',
    component: AdmissionInBBAComponent,
    data: {
      keywords: 'What Should You Know Before Applying for Admission in BBA?',
      description:
        'For students interested in management or business studies, Admission in BBA is an excellent choice to start their journey with.',
      title: 'What Should You Know Before Applying for Admission in BBA?'
    }
  },
  {
    path: 'msc-in-computer-science',
    component: MscInComputerScienceComponent,
    data: {
      keywords: 'Best M.SC College in Nagpur Maharashtra | GHRCACSN',
      description:
        'Take your computer science education further with M.Sc. Build on B.Sc. fundamentals and delve deeper into advanced topics for comprehensive expertise.',
      title: 'Best M.SC College in Nagpur Maharashtra | GHRCACSN'
    }
  },
  {
    path: 'top-bca-colleges-in-india',
    component: TopBCACollegesInIndiaComponent,
    data: {
      keywords:
        'Top BCA Colleges in India: Ranking the Best Programs for Computer Science',
      description:
        'BSc in Finance is not a cup for everyone. Unlike the UG in BBA Finance, one must go through an extensive study phase during BSc in Finance.',
      title:
        'Top BCA Colleges in India: Ranking the Best Programs for Computer Science'
    }
  },
  {
    path: 'account-details',
    component: FeesStructuresComponent,
    data: {
      keywords: 'Account Details | GHRCACSN',
      description: 'Account Details | GHRCACSN',
      title: 'Account Details | GHRCACSN'
    }
  },
  {
    path: 'future-of-data-science',
    component: FutureOfDataScienceComponent,
    data: {
      keywords: 'The Future of Data Science: BSc Benefits & Opportunities',
      description:
        'Discover the Future of Data Science and the exciting opportunities it brings in the ever-evolving field of data science.',
      title: 'The Future of Data Science: BSc Benefits & Opportunities'
    }
  },
  {
    path: 'specialization-for-your-m-sc-in-computer-science',
    component: SpecializationForYourMScInComputerScienceComponent,
    data: {
      keywords:
        'Choose the Right Specialization for Your M.Sc in Computer Science',
      description:
        'Unlock your potential with the perfect M.Sc specialization in Computer Science. Find expert guidance to choose the right path.  ',
      title: 'Choose the Right Specialization for Your M.Sc in Computer Science'
    }
  },
  {
    path: 'top-masters-programs-in-computer-management',
    component: TopMastersProgramsInComputerManagementComponent,
    data: {
      keywords: 'The Top Masters in Computer Management to Consider',
      description:
        'Discover the best Masters in Computer Management. Gain expertise and propel your career with these top-rated programs.',
      title: 'The Top Masters in Computer Management to Consider'
    }
  },
  {
    path: 'b-com-honours-program',
    component: BComHonoursProgramComponent,
    data: {
      keywords: 'Top 10 Colleges in India for B.Com Honours Program | GHRCACSN',
      description:
        'Discover the top 10 colleges in India for B.Com Honours program, offering exceptional education and endless opportunities for success.',
      title: 'Top 10 Colleges in India for B.Com Honours Program | GHRCACSN'
    }
  },
  {
    path: 'engfinity-club-installation-press-release',
    component: EngfinityClubInstallationPressReleaseComponent,
    data: {
      keywords:
        'Engfinity Club Installation Press Release  || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description:
        'Discover the top 10 colleges in India for B.Com Honours program, offering exceptional education and endless opportunities for success.',
      title: 'Engfinity Club Installation Press Release    '
    }
  },
  {
    path: 'best-colleges-ba-digital-marketing-nagpur',
    component: BestCollegesBaDigitalMarketingNagpurComponent,
    data: {
      keywords:
        'The Best Colleges for BA in Digital Marketing Courses in Nagpur   || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description:
        ' Fuel your digital marketing career! Explore the best colleges for BA in Digital Marketing courses in Nagpur. Elevate your skills and future.      ',
      title:
        'The Best Colleges for BA in Digital Marketing Courses in Nagpur     '
    }
  },
  {
    path: 'bcom-computer-application',
    component: BcomComputerApplicationComponent,
    data: {
      keywords:
        'Top Career Paths for Graduates with a B.Com in Computer Application || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description:
        ' B.Com in Computer Application is a specialized degree that epitomizes this synergy, providing graduates       ',
      title:
        'Top Career Paths for Graduates with a B.Com in Computer Application      '
    }
  },
  {
    path: 'bcom-computer-application',
    component: BcomComputerApplicationComponent,
    data: {
      keywords:
        'Top Career Paths for Graduates with a B.Com in Computer Application || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description:
        ' B.Com in Computer Application is a specialized degree that epitomizes this synergy, providing graduates       ',
      title:
        'Top Career Paths for Graduates with a B.Com in Computer Application      '
    }
  },
  {
    path: 'future-bsc-it-career-opportunities',
    component: FutureBscItCareerOpportunitiesComponent,
    data: {
      keywords:
        'The Future of BSc IT: Emerging Technologies and Career Opportunities',
      description:
        'Explore the future of BSc IT! Navigate emerging technologies and career prospects in The Future of BSc IT. Your gateway to tech excellence.       ',
      title:
        'The Future of BSc IT: Emerging Technologies and Career Opportunities      '
    }
  },
  {
    path: 'business-guide-bba-courses',
    component: BusinessGuideBbaCoursesComponent,
    data: {
      keywords:
        'Unlocking the World of Business: A Comprehensive Guide to BBA Courses',
      description:
        'Learn all about BBA courses! Unlocking the World of Business is your complete guide to understanding the world of business studies.',
      title:
        'Unlocking the World of Business: A Comprehensive Guide to BBA Courses       '
    }
  },
  {
    path: 'e-commerce-digital-marketing-enhancing',
    component: ECommerceDigitalMarketingEnhancingComponent,
    data: {
      keywords:
        'E-Commerce and Digital Marketing: Enhancing the Digital Age in Business',
      description:
        'Transform business in the digital era! Explore E- Commerce and Digital Marketing, unlocking strategies for success in the online marketplace.',
      title:
        'E-Commerce  and Digital Marketing: Enhancing the Digital Age in Business       '
    }
  },
  {
    path: 'gyan-manthan',
    component: GyanManthanComponent,
    data: {
      keywords:
        '“GYANMANTHAN” - A Management Fest at GHRCCST, Nagpur  || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description: '“GYANMANTHAN” - A Management Fest at GHRCCST, Nagpur      ',
      title: '“GYANMANTHAN” - A Management Fest at GHRCCST, Nagpur       '
    }
  },
  {
    path: 'toastmasters-club',
    component: ToastmastersClubComponent,
    data: {
      keywords:
        '“Toastmaster Club  || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description: '“Toastmaster Club      ',
      title: '“Toastmaster Club       '
    }
  },
  {
    path: 'bsc-economics-program-tips',
    component: BscEconomicsProgramTipsComponent,
    data: {
      keywords:
        'How to Excel in a BSc in Economics Program: Study Tips and Strategies?',
      description:
        'Boost your BSc in Economics! Learn smart study tips with How to Excel in a BSc in Economics Program. Ace your exams and enjoy success!',
      title:
        'How to Excel in a BSc in Economics Program: Study Tips and Strategies?       '
    }
  },
  {
    path: 'bsc-economics-and-finance',
    component: BscEconomicsAndFinanceComponent,
    data: {
      keywords: 'Bsc Economics And Finance: Achieving Financial Stability',
      description:
        'Boost your BSc in Economics! Learn smart study tips with How to Excel in a BSc in Economics Program. Ace your exams and enjoy success!',
      title: 'Bsc Economics And Finance: Achieving Financial Stability'
    }
  },
  {
    path: 'induction-program',
    component: InductionProgramComponent,
    data: {
      keywords:
        'Induction Program: G H Raisoni College of Arts, Commerce, Science Nagpur',
      description: ' G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'Induction Program: G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'raisoni-mandi',
    component: RaisoniMandiComponent,
    data: {
      keywords:
        'Raisoni Mandi: G H   Raisoni College of Arts, Commerce, Science Nagpur',
      description: ' G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'Raisoni Mandi: G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'farewell-party',
    component: FarewellPartyComponent,
    data: {
      keywords:
        'Farewell Party: G H   Raisoni College of Arts, Commerce, Science Nagpur',
      description: ' G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'Farewell Party: G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'farewell-ceremony',
    component: FarewellCeremonyComponent,
    data: {
      keywords:
        'Farewell Ceremony: G H   Raisoni College of Arts, Commerce, Science Nagpur',
      description: ' G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'Farewell Ceremony: G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'cynosure',
    component: CynosureComponent,
    data: {
      keywords:
        'Cynosure: G H   Raisoni College of Arts, Commerce, Science Nagpur',
      description: ' G H Raisoni College of Arts, Commerce, Science Nagpur',
      title: 'Cynosure: G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'installation-program',
    component: InstallationProgramComponent,
    data: {
      keywords:
        'Installation Program: G H   Raisoni College of Arts, Commerce, Science Nagpur',
      description: ' G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'Installation Program: G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'rakhi-making-competition',
    component: RakhiMakingCompetitionComponent,
    data: {
      keywords:
        'Mission Voting Camping : G H   Raisoni College of Arts, Commerce, Science Nagpur',
      description: ' G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'Rakhi Making Competition : G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'mission-voting-camping',
    component: MissionVotingCampingComponent,
    data: {
      keywords:
        'Mission Voting Camping : G H   Raisoni College of Arts, Commerce, Science Nagpur',
      description: ' G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'Mission Voting Camping : G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },

  {
    path: 'ganesh-chaturthi',
    component: GaneshChaturthiComponent,
    data: {
      keywords:
        'Ganesh Chaturthi : G H   Raisoni College of Arts, Commerce, Science Nagpur',
      description: ' G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'Ganesh Chaturthi : G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'installation-ceremony',
    component: InstallationCeremonyComponent,
    data: {
      keywords:
        'Installation Ceremony : G H   Raisoni College of Arts, Commerce, Science Nagpur',
      description: ' G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'Installation Ceremony : G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'engfinity-club',
    component: EngfinityClubComponent,
    data: {
      keywords:
        'engfinity-club : G H   Raisoni College of Arts, Commerce, Science Nagpur',
      description: ' G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'engfinity-club : G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'big-boss',
    component: BigBossComponent,
    data: {
      keywords:
        'big-boss : G H   Raisoni College of Arts, Commerce, Science Nagpur',
      description: ' G H Raisoni College of Arts, Commerce, Science Nagpur',
      title: 'big-boss : G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'top-bsc-finance-colleges-nagpur',
    component: TopBscFinanceCollegesNagpurComponent,
    data: {
      keywords:
        'Top Bsc Finance Colleges Nagpur : G H   Raisoni College of Arts, Commerce, Science Nagpur',
      description:
        'Explore the top BSc Finance colleges in Nagpur for 2025. Find the best finance programs, faculty, and career opportunities in the heart of Nagpur.',
      title: 'Top BSc Finance Colleges in Nagpur | Best Finance Courses 2025'
    }
  },
  {
    path: 'deep-milan',
    component: DeepMilanComponent,
    data: {
      keywords:
        'Deep Milan : G H Raisoni College of Arts, Commerce, Science Nagpur',
      description: ' G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'Deep Milan | G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'news-analysis',
    component: NewsAnalysisComponent,
    data: {
      keywords:
        'News Analysis : G H Raisoni College of Arts, Commerce, Science Nagpur',
      description: ' G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'News Analysis | G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'mandatory-disclosure',
    component: MandatoryDisclosureComponent,
    data: {
      keywords:
        'andatory Disclosure : G H Raisoni College of Arts, Commerce, Science Nagpur',
      description: ' G H Raisoni College of Arts, Commerce, Science Nagpur',
      title:
        'andatory Disclosure | G H Raisoni College of Arts, Commerce, Science Nagpur'
    }
  },
  {
    path: 'mcm-course-in-nagpur',
    component: McmCourseInNagpurComponent,
    data: {
      keywords: 'MCM Course in Nagpur: Unlock the Secrets to Career Success',
      description:
        ' Explore the MCM course in Nagpur and discover the hidden strategies to excel in the competitive job market with expert guidance and skills.',
      title: 'MCM Course in Nagpur: Unlock the Secrets to Career Success'
    }
  },
  {
    path: 'msc-computer-science-colleges-in-nagpur',
    component: MscComputerScienceCollegesInNagpurComponent,
    data: {
      keywords: 'Top MSc Computer Science Colleges in Nagpur | GHRCACSN',
      description:
        'Discover the top 10 MSC Computer Science colleges in Nagpur offering exceptional education, innovation, and career growth opportunities',
      title: 'Top MSc Computer Science Colleges in Nagpur | GHRCACSN'
    }
  },
  {
    path: 'kite-flying-festival',
    component: KiteFlyingFestivalComponent,
    data: {
      keywords: 'Kite Flying Festival | GHRCACSN',
      description:
        'Discover the top 10 MSC Computer Science colleges in Nagpur offering exceptional education, innovation, and career growth opportunities',
      title: 'Kite Flying Festival | GHRCACSN'
    }
  },

  {
    path: 'farewell-party-twentyfive',
    component: FarewellPartyTwentyfiveComponent,
    data: {
      keywords: 'Farewell Party 2025| GHRCACSN',
      description: 'Farewell Party 2025',
      title: 'Farewell Party 2025| GHRCACSN'
    }
  },
  {
    path: 'pickleball-inauguration',
    component: PickleballInaugurationComponent,
    data: {
      keywords: 'Pickleball Inauguration| GHRCACSN',
      description: 'Pickleball Inauguration',
      title: 'Pickleball Inauguration| GHRCACSN'
    }
  },
  {
    path: 'engfinity2025',
    component: Engfinity2025Component,
    data: {
      keywords: 'Engfinity 2025 | GHRCACSN',
      description: 'Engfinity 2025 ',
      title: 'Engfinity 2025 | GHRCACSN'
    }
  },
  {
    path: 'creating-unicorn',
    component: CreatingUnicornComponent,
    data: {
      keywords: 'Creating A Unicorn | GHRCACSN',
      description: 'Creating A Unicorn ',
      title: 'Creating A Unicorn | GHRCACSN'
    }
  },
  {
    path: 'miss-nation-competition',
    component: MissNationCompetitionComponent,
    data: {
      keywords: 'Miss Nation Competition | GHRCACSN',
      description: 'Miss Nation Competition ',
      title: 'Miss Nation Competition | GHRCACSN'
    }
  },
  {
    path: 'toastmasters',
    component: ToastmastersComponent,
    data: {
      keywords: 'Toastmasters | GHRCACSN',
      description: 'Toastmasters ',
      title: 'Toastmasters | GHRCACSN'
    }
  },

  {
    path: 'events-new',
    component: EventsNewComponent,
    data: {
      keywords:
        'Events || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR',
      description:
        'Discover upcoming events at G H Raisoni College, Nagpur. Engage in enriching activities and academic gatherings.',
      title:
        'Events || G H RAISONI COLLEGE OF COMMERCE, SCIENCE AND TECHNOLOGY, NAGPUR'
    }
  },
  {
    path: 'sada-gyan-series',
    component: SadaGyanSeriesComponent,
    data: {
      keywords: 'Sada Gyan Series | GHRCACSN',
      description: 'Sada Gyan Series ',
      title: 'Sada Gyan Series | GHRCACSN'
    }
  },
  {
    path: 'kashti-inauguration',
    component: KashtiInaugurationComponent,
    data: {
      keywords: 'kashti-inauguration | GHRCACSN',
      description: 'kashti-inauguration ',
      title: 'kashti-inauguration | GHRCACSN'
    }
  },
  {
    path: 'raisoni-premier-league',
    component: RaisoniPremierLeagueComponent,
    data: {
      keywords: 'raisoni-premier-league| GHRCACSN',
      description: 'raisoni-premier-league',
      title: 'raisoni-premier-league| GHRCACSN'
    }
  },
  {
    path: 'chatrapati-shivaji-maharaj-jaynti',
    component: ChatrapatiShivajiMaharajJayntiComponent,
    data: {
      keywords: 'chatrapati-shivaji-maharaj-jaynti| GHRCACSN',
      description: 'chatrapati-shivaji-maharaj-jaynti',
      title: 'chatrapati-shivaji-maharaj-jaynti| GHRCACSN'
    }
  },
  {
    path: 'setu',
    component: SetuComponent,
    data: {
      keywords: 'setu| GHRCACSN',
      description: 'setu',
      title: 'setu| GHRCACSN'
    }
  },
  {
    path: 'rahe',
    component: RaheComponent,
    data: {
      keywords: 'rahe| GHRCACSN',
      description: 'rahe',
      title: 'rahe| GHRCACSN'
    }
  },
  {
    path: 'farewell',
    component: FarewellComponent,
    data: {
      keywords: 'Farewell| GHRCACSN',
      description: 'Farewell',
      title: 'Farewell| GHRCACSN'
    }
  },
  { path: '**', redirectTo: '/' }
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
